// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <div class="no-print" command-access-context="\$ctrl.commandAccessContext(\$ctrl.selectedLoan, \$ctrl.profile)">

    <sub-header header="'Loans'">
      <div class="right-header-panel" ng-if="\$ctrl.profile.status && \$ctrl.profile.status !== 'CLOSED'">
        <div class="switch">
          <input id="closed-table-switch"
                 type="checkbox"
                 ng-model="\$ctrl.showClosed"
                 ng-click="\$ctrl.toggleClosedLoans()"
                 ng-disabled="\$ctrl.onlyClosedLoans()"/>
          <label for="closed-table-switch">Show closed loans</label>
        </div>
        <button command-access="CreateLoan" class="btn btn-primary" ng-click="\$ctrl.createNew()">Create new</button>
        <button command-access="CreateConsolidatedLoan" class="btn btn-primary" ng-click="\$ctrl.consolidate()">Consolidate</button>
      </div>
    </sub-header>

    <customer-nongroup-access ng-if="\$ctrl.profile.status && \$ctrl.profile.status !== 'CLOSED'"></customer-nongroup-access>

    <form-section>

      <div class="container--with-mini-menu">

        <div class="loans">
          <table class="table" at-table at-list="\$ctrl.visibleLoans">
            <thead></thead>
            <tbody class="tbody">
            <tr ng-click="\$ctrl.selectLoan(item)"
                ng-class="{'selected': item == \$ctrl.selectedLoan, 'orange': item.status == 'INVALID'}"
                class="table__row--clickable">
              <td at-title="No">
                {{\$index+1}}
              </td>
              <td at-title="Product name">{{item.loanType.productDefinition.productName}}</td>
              <td at-title="Product Number">
                {{\$ctrl.formatProductAndExtraNumber(item)}}
              </td>
              <td at-title="Group name">{{item.groupLoanName || '-'}}</td>
              <td at-implicit at-attribute="status" at-title="Status"></td>
              <td at-title="Outstanding balance">
                {{item.principalBalance | nxCurrency}}
                <span class="label status--success late-check" ng-show="item.lateCheckAwaitingAmount"
                      title="{{item.lateCheckAwaitingAmount | nxCurrency}}">Late Check</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="mini-menu right-details" ng-show="\$ctrl.selectedLoan">
          <ul class="nav-tabs">
            <li class="active"><a data-target="#operations" data-toggle="tab">Operations</a></li>
            <li><a data-target="#parameters" data-toggle="tab">Parameters</a></li>
            <li><a data-target="#account-information" data-toggle="tab">Info</a></li>
            <li ng-if="\$ctrl.loanIsReleasedButNotClosed(\$ctrl.selectedLoan)"><a data-target="#metadata"
                                                                                data-toggle="tab">Metadata</a></li>
          </ul>

          <div class="tab-content">
            <div class="tab-pane active" id="operations">
              <div class="operation-row">
                <div class="alert"
                     ng-if="\$ctrl.isLoanLocked && !(\$ctrl.isLockedByLos() || \$ctrl.isLosConsolidationLoan())">
                  {{ \$ctrl.lockMessage }}
                </div>
                <tooltip class="alert" ng-if="\$ctrl.isLockedByLos() || \$ctrl.isLosConsolidationLoan()">
                  <tooltip-wrapped-element></tooltip-wrapped-element>
                  <tooltip-body>
                      <p>{{ \$ctrl.lockMessage || \$ctrl.infoMessage }}</p>
                  </tooltip-body>
                </tooltip>
                <!-- loan payment -->
                <div class="btn-group"
                     ng-if="\$ctrl.loanIsReleasedButNotClosed(\$ctrl.selectedLoan)"
                     command-access="PayLoanByCash, PayLoanByCheck, PayLoanByTransfer, PayLoanByGL">
                  <button class="btn dropdown-toggle"
                          data-toggle="dropdown"
                          ng-disabled="\$ctrl.isLoanLocked"
                          ng-class="{'btn-success': !\$ctrl.isLoanLocked, 'btn-default': \$ctrl.isLoanLocked}">
                    Pay <span class="caret">
                  </span>
                  </button>
                  <ul class="dropdown-menu">
                    <li command-access="PayLoanByCash"><a ng-click="\$ctrl.payInCash()">Pay by Cash</a></li>
                    <li command-access="PayLoanByCheck"><a ng-click="\$ctrl.payInCheck()">Pay by Check</a></li>
                    <li command-access="PayLoanByGL"><a ng-click="\$ctrl.payByGeneralLedger()">Pay by General Ledger</a>
                    </li>
                    <li command-access="PayLoanByTransfer"><a ng-click="\$ctrl.payByTransfer()">Pay by Transfer</a></li>
                  </ul>
                </div>

                <div class="btn-group"
                     ng-show="\$ctrl.releaseAllowed()">
                  <button class="btn btn-success dropdown-toggle" data-toggle="dropdown" type="button">
                    Release
                    <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu">
                    <li command-access="ReleaseRestructuredLoan" ng-if="\$ctrl.isRestructuredLoan() && !\$ctrl.selectedLoan.checkPreparationId">
                      <a ng-click="\$ctrl.releaseBy('RESTRUCTURE')">
                        Release restructured loan
                      </a>
                    </li>
                    <li command-access="ReleaseLoanByCC" ng-if="!\$ctrl.isRestructuredLoan() && !\$ctrl.selectedLoan.checkPreparationId">
                      <a ng-click="\$ctrl.releaseByCC()">
                        {{'RELEASE_LOAN_BY_CC' | translateEnum:'LABEL'}}
                      </a>
                    </li>
                    <li command-access="ReleaseLoanByCash" ng-if="!\$ctrl.isRestructuredLoan() && !\$ctrl.selectedLoan.checkPreparationId">
                      <a ng-click="\$ctrl.releaseBy('CASH')">
                        Release by cash
                      </a>
                    </li>
                    <li command-access="ReleaseLoanByCreditToAccount" ng-if="!\$ctrl.isRestructuredLoan() && !\$ctrl.selectedLoan.checkPreparationId">
                      <a ng-click="\$ctrl.releaseBy('CREDIT_TO_ACCOUNT')">
                        Release by credit to account
                      </a>
                    </li>
                    <li command-access="ReleaseLoanByCheck" ng-if="!\$ctrl.isRestructuredLoan() && \$ctrl.releaseAllowed()" >
                      <a ng-click="\$ctrl.releaseBy('CHECK')">
                        Release by check
                      </a>
                    </li>
                    <li command-access="ReleaseLoanByGL" ng-if="!\$ctrl.isRestructuredLoan() && !\$ctrl.selectedLoan.checkPreparationId">
                      <a ng-click="\$ctrl.releaseBy('GENERAL_LEDGER')">
                        Release by GL
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="btn-group"
                     ng-if="\$ctrl.loanIsReleasedButNotClosed(\$ctrl.selectedLoan)"
                     command-access="PreterminateLoanByCash, PreterminateLoanByTransfer, PreterminateLoanByGL">
                  <button class="btn
                   dropdown-toggle"
                          data-toggle="dropdown"
                          ng-disabled="\$ctrl.isLoanLocked || \$ctrl.isLoanWrittenOff()"
                          ng-class="{'btn-primary': !\$ctrl.isLoanLocked, 'btn-default': \$ctrl.isLoanLocked}">
                    {{'pre-terminate' | translate:'LOAN'}}<span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu">
                    <li command-access="PreterminateLoanByCash"><a ng-click="\$ctrl.preTerminateByCash()">{{'pre-terminate-by-cash'
                      | translate:'LOAN'}}</a></li>
                    <li command-access="PreterminateLoanByTransfer"><a ng-click="\$ctrl.preTerminateByTransfer()">{{'pre-terminate-by-transfer'
                      | translate:'LOAN'}}</a></li>
                    <li command-access="PreterminateLoanByGL"><a ng-click="\$ctrl.preTerminateByGL()">{{'pre-terminate-by-gl'
                      | translate:'LOAN'}}</a></li>
                  </ul>
                </div>

                <button command-access="WaiveLoan"
                        class="btn"
                        ng-click="\$ctrl.waiveLoan()"
                        ng-if="\$ctrl.loanIsReleasedButNotClosed(\$ctrl.selectedLoan)"
                        ng-disabled="\$ctrl.isLoanLocked"
                        ng-class="{'btn-info': !\$ctrl.isLoanLocked, 'btn-default': \$ctrl.isLoanLocked}">
                  Waive
                </button>

                <button
                  command-access="BatchCreateLoanPDC"
                  class="btn"
                  ng-click="\$ctrl.issuePdc()"
                  ng-if="\$ctrl.loanIsReleasedButNotClosed(\$ctrl.selectedLoan)"
                  ng-disabled="\$ctrl.isLoanLocked  || \$ctrl.isLoanWrittenOff()"
                  ng-class="{'btn-success': !\$ctrl.isLoanLocked, 'btn-default': \$ctrl.isLoanLocked}">
                  Issue PDC
                </button>

                <div class="btn-group">
                  <button class="btn btn-success dropdown-toggle" data-toggle="dropdown" type="button">Prints&nbsp;<span
                    class="caret"></span></button>
                  <ul class="dropdown-menu">
                    <li><a ng-click="\$ctrl.paymentReport()">Payment report</a></li>
                    <li><a ng-click="\$ctrl.amortizationScheduleReport()">Amortization schedule report</a></li>
                    <li ng-if="\$ctrl.statementOfAccountActive"><a ng-click="\$ctrl.statementOfAccount()">Statement of account</a></li>
                    <li><a ng-click="\$ctrl.statementOfAccountPerAmortization()">Statement of account - Per amortization </a></li>
                    <li><a ng-click="\$ctrl.statementOfAccountTotal()">Statement of account - Totals</a></li>
                    <li><a ng-click="\$ctrl.promissoryNote()">Promissory note</a></li>
                    <li ng-if="\$ctrl.isLoanInquiryPrintActive"><a ng-click="\$ctrl.loanInquiry()">Loan inquiry</a></li>
                    <li ng-if="\$ctrl.isDisclosureStatementActive()">
                      <a ng-click="\$ctrl.disclosureStatement()">Disclosure Statement</a>
                    </li>
                    <li ng-if="\$ctrl.isReleaseToAccountStatementActive()">
                      <a ng-click="\$ctrl.releaseToAccountStatement()">Release to account statement</a>
                    </li>
                    <li ng-if="\$ctrl.isPrintLoanCheckAvailable()">
                      <a ng-click="\$ctrl.printCheck()">Check print</a>
                    </li>
                    <li ng-if="\$ctrl.hasLetters()"><a ng-click="\$ctrl.letters()">Collection Letters</a></li>
                    <li ng-if="\$ctrl.selectedLoan.uidLedger && \$ctrl.selectedLoan.status !== 'INACTIVE'"><a ng-click="\$ctrl.rebatesLedgerReport()">Rebates ledger report</a></li>
                  </ul>
                </div>

                <button command-access="CreateRestructuredLoan"
                        class="btn"
                        ng-click="\$ctrl.restructureLoan()"
                        ng-if="\$ctrl.isLoanRestructureAllowed()"
                        ng-disabled="\$ctrl.isLoanLocked || \$ctrl.isLoanWrittenOff()"
                        ng-class="{'btn-primary': !\$ctrl.isLoanLocked, 'btn-default': \$ctrl.isLoanLocked}">
                  Restructure
                </button>

                <button command-access="CreateRenewedLoan"
                        class="btn"
                        ng-if="\$ctrl.isRenewalAllowed()"
                        ng-click="\$ctrl.renewLoan()"
                        ng-disabled="\$ctrl.isLoanLocked || \$ctrl.isLoanWrittenOff()"
                        ng-class="{'btn-primary': !\$ctrl.isLoanLocked, 'btn-default': \$ctrl.isLoanLocked}">
                  Renew
                </button>

                <button class="btn"
                        command-access="RepriceLoan"
                        ng-if="\$ctrl.isRepriceAllowed()"
                        ng-click="\$ctrl.reprice(\$ctrl.selectedLoan.loanInformation.interestSetting)"
                        ng-disabled="\$ctrl.isLoanLocked"
                        ng-class="{'btn-primary': !\$ctrl.isLoanLocked, 'btn-default': \$ctrl.isLoanLocked}">
                  Reprice
                </button>

                <button command-access="CreateReconstructedLoan"
                        class="btn"
                        ng-click="\$ctrl.reconstructLoan()"
                        ng-if="\$ctrl.isLoanReconstructionAllowed()"
                        ng-disabled="\$ctrl.isLoanLocked || \$ctrl.isLoanWrittenOff()"
                        ng-class="{'btn-primary': !\$ctrl.isLoanLocked, 'btn-default': \$ctrl.isLoanLocked}">
                  Reconstruct
                </button>

                <!-- loan edit -->
                <div class="btn-group" ng-if="\$ctrl.selectedLoan.status !== 'CLOSED'"
                     command-access="EditLoanInformation, EditLoanInterestAccrual, EditLoanAllowanceForCreditLosses, EditLoanMetadata, EditLoanAmortizationWithoutPrincipal, EditLoanAmortizationWithPrincipal, EditLoanParametersAndCharges, RecalculateAmortizationSchedule">
                  <button class="btn dropdown-toggle"
                          data-toggle="dropdown"
                          ng-disabled="\$ctrl.isLoanLocked"
                          ng-class="{'btn-warning': !\$ctrl.isLoanLocked, 'btn-default': \$ctrl.isLoanLocked}">
                    Edit
                    <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu">
                    <li ng-if="\$ctrl.selectedLoan.status === 'INACTIVE'" command-access="EditLoanParametersAndCharges">
                      <a ng-click="\$ctrl.editParamsAndCharges()">
                        Edit loan parameters and charges
                      </a>
                    </li>
                    <li
                      ng-if="!['INACTIVE', 'PENDING', 'CLOSED', 'ROPA'].includes(\$ctrl.selectedLoan.status)"
                      command-access="RecreateDiscountChargesLedger">
                      <a ng-click="\$ctrl.recreateDiscountChargesLedger()">
                        Re-create discount charges ledger
                      </a>
                    </li>
                    <li
                      ng-if="\$ctrl.selectedLoan.status !== 'ROPA'"
                      command-access="EditLoanInformation">
                      <a ng-click="\$ctrl.editInformation()">
                        Edit loan information
                      </a>
                    </li>
                    <li
                      ng-if="\$ctrl.selectedLoan.status !== 'ROPA'"
                      command-access="EditLoanDocuments">
                      <a ng-click="\$ctrl.editLoanDocuments()">
                        Edit loan documents
                      </a>
                    </li>
                    <li
                      ng-if="\$ctrl.selectedLoan.status !== 'ROPA'"
                      command-access="EditLoanInterestAccrual" ng-if="\$ctrl.selectedLoan.allowAccrual">
                      <a ng-click="\$ctrl.editInterestAccrual()">
                        Edit loan interest accrual
                      </a>
                    </li>
                    <li
                      ng-if="\$ctrl.selectedLoan.status !== 'ROPA'"
                      command-access="EditLoanAllowanceForCreditLosses">
                      <a ng-click="\$ctrl.editCreditLossesAllowance()">
                        Edit allowance for credit losses
                      </a>
                    </li>
                    <li command-access="EditLoanMetadata" ng-if="\$ctrl.selectedLoan.status !== 'ROPA'&& \$ctrl.loanIsReleasedButNotClosed(\$ctrl.selectedLoan)">
                      <a ng-click="\$ctrl.editMetadata()">
                        Edit metadata
                      </a>
                    </li>
                    <li command-access="EditLoanRates" ng-if="\$ctrl.selectedLoan.status !== 'ROPA' && \$ctrl.loanIsReleasedButNotClosed(\$ctrl.selectedLoan)">
                      <a ng-click="\$ctrl.editRates()">
                        Edit loan rates
                      </a>
                    </li>
                    <li command-access="EditLoanAmortizationWithoutPrincipal" ng-if="\$ctrl.selectedLoan.status !== 'ROPA'">
                      <a ng-click="\$ctrl.editLoanAmortizationWithoutPrincipal()">
                        Edit amortization schedule
                      </a>
                    </li>
                    <li command-access="EditLoanAmortizationWithPrincipal">
                      <a ng-click="\$ctrl.editLoanAmortizationWithPrincipal()">
                        Edit amortization schedule (inc. principal)
                      </a>
                    </li>
                    <li command-access="RecalculateAmortizationSchedule"
                        ng-if="\$ctrl.selectedLoan.status == 'INACTIVE' && \$ctrl.selectedLoan.releaseAllowedDate">
                      <a ng-click="\$ctrl.recalculateAmortizationSchedule()">
                        Recalculate amortization schedule
                      </a>
                    </li>
                    <li
                      ng-if="\$ctrl.selectedLoan.status !== 'ROPA'"
                      command-access="EditLoanCoMakers">
                      <a ng-click="\$ctrl.editCoMaker()">
                        Edit co-makers
                      </a>
                    </li>
                  </ul>
                </div>

                <button class="btn"
                        command-access="CloseLoan"
                        ng-if="!(['INACTIVE', 'PENDING', 'CLOSED'].includes(\$ctrl.selectedLoan.status)) && \$ctrl.hasZeroOutstandingBalance(\$ctrl.selectedLoan)"
                        ng-click="\$ctrl.closeLoan()"
                        ng-disabled="\$ctrl.isLoanLocked"
                        ng-class="{'btn-primary': !\$ctrl.isLoanLocked, 'btn-default': \$ctrl.isLoanLocked}">
                  Close
                </button>

                <button class="btn"
                        command-access='AssignLoanToGroup'
                        ng-if="\$ctrl.isLoanAssignToGroupAllowed(\$ctrl.selectedLoan)"
                        ng-click="\$ctrl.assignLoanToGroup()"
                        ng-disabled="\$ctrl.isLoanLocked || !\$ctrl.isTypeAssignableToGroup()"
                        ng-class="{'btn-inverse': !\$ctrl.isLoanLocked, 'btn-default': \$ctrl.isLoanLocked}">
                  Assign to group
                </button>

                <button class="btn"
                        command-access="TransferLoanToRopa"
                        ng-if="\$ctrl.loanIsReleasedButNotClosed(\$ctrl.selectedLoan)"
                        ng-click="\$ctrl.transferToRopa()"
                        ng-disabled="\$ctrl.isLoanLocked || \$ctrl.isLoanWrittenOff()"
                        ng-class="{'btn-danger': !\$ctrl.isLoanLocked, 'btn-default': \$ctrl.isLoanLocked}">
                  Transfer to ROPA
                </button>

                <button command-access="WriteOffLoan"
                        class="btn"
                        type="button"
                        ng-click="\$ctrl.writeOffLoan()"
                        ng-if="\$ctrl.isWriteOffAllowed()"
                        ng-disabled="\$ctrl.isLoanLocked"
                        ng-class="{'btn-danger': !\$ctrl.isLoanLocked, 'btn-default': \$ctrl.isLoanLocked}">
                  Write Off
                </button>

                <button class="btn"
                        command-access="UidRebate"
                        ng-if="\$ctrl.hasAccruedLedgerEntries(\$ctrl.selectedLoan)"
                        ng-click="\$ctrl.uidRebate()"
                        ng-disabled="\$ctrl.isLoanLocked"
                        ng-class="{'btn-danger': !\$ctrl.isLoanLocked, 'btn-default': \$ctrl.isLoanLocked}">
                  Rebate
                </button>

                <button class="btn"
                        command-access="DeleteLoan"
                        ng-if="\$ctrl.deleteAllowed()"
                        ng-click="\$ctrl.deleteLoan()"
                        ng-disabled="\$ctrl.isLoanLocked"
                        ng-class="{'btn-danger': !\$ctrl.isLoanLocked, 'btn-default': \$ctrl.isLoanLocked}">
                  Delete
                </button>

                <button class="btn btn-primary"
                        command-access="ReopenLoan"
                        ng-if="\$ctrl.selectedLoan.status == 'CLOSED'"
                        ng-click="\$ctrl.reopenLoan()">
                  Reopen loan
                </button>
              </div>
            </div>
            <div class="tab-pane" id="parameters">
              <div class="detail-rows">
                <div class="info-detail">
                  <span class="key">Number:</span>
                  <span class="value">{{\$ctrl.selectedLoan.productNumber}}
                </span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.remadeFromLoanIds.length > 0 || \$ctrl.selectedLoan.renewedLoanId">
                  <span class="key">Remade from:</span>
                  <span class="value" ng-repeat="productNumber in \$ctrl.remadeProductNumbers">{{productNumber}}{{!\$last ? ', ' : ''}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.isAddOnRateAmortizationType()">
                  <span class="key">Interest rate (monthly add-on):</span><span class="value">{{\$ctrl.selectedLoan.monthlyInterestRate}}%</span>
                </div>
                <div class="info-detail"><span class="key">Interest rate (annual):</span><span class="value">{{\$ctrl.selectedLoan.interestRate}}%</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.discountChargesRate"><span class="key">Discount charges rate:</span><span class="value">{{\$ctrl.selectedLoan.discountChargesRate}}%</span>
                </div>
                <div class="info-detail"><span class="key">EIR (periodic):</span><span class="value">{{\$ctrl.selectedLoan.eirPeriodic}}%</span>
                </div>
                <div class="info-detail"><span class="key">EIR (annual):</span><span class="value">{{\$ctrl.selectedLoan.eirAnnual}}%</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.interestType === 'ADD_ON_RATE'"><span class="key">Gross EIR (periodic):</span><span class="value">{{\$ctrl.selectedLoan.grossEirPeriodic}}%</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.interestType === 'ADD_ON_RATE'"><span class="key">Gross EIR (annual):</span><span class="value">{{\$ctrl.selectedLoan.grossEirAnnual}}%</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.interestType === 'ADD_ON_RATE'"><span class="key">Add-on rate (periodic):</span><span class="value">{{\$ctrl.selectedLoan.intervalInterestRate}}%</span>
                </div>
                <div class="info-detail"><span class="key">Amortization type: </span><span class="value">{{\$ctrl.selectedLoan.interestCalculationMethod | prettyEnum}} / {{\$ctrl.selectedLoan.amortizationType | prettyEnum}}</span>
                </div>
                <div class="info-detail"><span class="key">Term in days:
                  </span><span class="value">{{\$ctrl.selectedLoan.term}}</span>
                  <span
                    ng-if="\$ctrl.selectedLoan.termAdjustment">(+ {{\$ctrl.selectedLoan.termAdjustment}} adjustment)</span>
                </div>
                <div class="info-detail"><span class="key">Payment interval:</span><span class="value">{{\$ctrl.selectedLoan.paymentIntervalDefinition.name}}</span>
                </div>
                <div class="info-detail"><span class="key">Total principal:</span><span class="value">{{\$ctrl.selectedLoan.principalAmount | nxCurrency}}</span>
                </div>
                <div class="info-detail"><span class="key">Outstanding principal:</span>
                  <span
                    ng-class="\$ctrl.selectedLoan.amortizationSchedule.totalBalance.principal === \$ctrl.selectedLoan.principalBalance ? 'value' : 'text-alert'">
                    {{\$ctrl.selectedLoan.principalBalance | nxCurrency}}
                  </span>
                </div>
                <div class="info-detail"><span class="key">Loan balance:</span>
                  <span>
                    {{\$ctrl.selectedLoan.balance * -1 | nxCurrency}}
                  </span>
                </div>
                <div class="info-detail"><span class="key">Total interests:</span><span class="value">{{\$ctrl.selectedLoan.interestAmount | nxCurrency}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.uidLedger">
                  <span class="key">Advance interest:</span>
                  <span class="value">{{\$ctrl.selectedLoan.uidLedger.totalUnearnedInterest | nxCurrency}}</span>
                </div>
                <div class="info-detail"><span class="key">Outstanding interests:</span>
                  <span
                    ng-class="\$ctrl.selectedLoan.amortizationSchedule.totalBalance.interest === \$ctrl.selectedLoan.interestBalance ? 'value' : 'text-alert'">
                    {{\$ctrl.selectedLoan.interestBalance | nxCurrency}}
                  </span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.allowAccrual">
                  <span class="key">Accrued interest:</span>
                  <span class="value">
                    {{\$ctrl.selectedLoan.accruedInterest | nxCurrency}}
                  </span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.allowAccrual">
                  <span class="key">Accrual limit:</span>
                  <span class="value">
                    {{\$ctrl.selectedLoan.accrualLimit}}
                  </span>
                </div>
                <div class="info-detail"><span class="key">Release amount:</span><span class="value">{{\$ctrl.selectedLoan.releaseAmount | nxCurrency}}</span>
                </div>
                <div class="info-detail"><span class="key">Maturity date:</span><span class="value">{{\$ctrl.selectedLoan.maturityDate | prettyDate}}</span>
                </div>
                <div class="info-detail"><span class="key">Date granted:</span><span class="value">{{\$ctrl.selectedLoan.grantDate | prettyDate}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.loanType.cycleCounting">
                  <span class="key">Cycle:</span>
                  <span ng-if="\$ctrl.selectedLoan.cycle" class="value">{{\$ctrl.selectedLoan.cycle}}</span>
                  <span ng-if="!\$ctrl.selectedLoan.cycle" class="value">(cycle will be updated upon release)</span>
                </div>
                <div class="info-detail"><span class="key">Created by:</span><span class="value">{{\$ctrl.selectedLoan.user.effectiveName}}</span>
                </div>
                <div class="info-detail"><span class="key">Created in branch:</span><span class="value">{{\$ctrl.selectedLoan.branch.name}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Co-Makers:</span>
                  <span class="value" ng-repeat="coMaker in \$ctrl.selectedLoanCoMakers">
                    [ {{coMaker.customerNumber}} ][ {{coMaker.effectiveName}} ]{{\$last ? '' : ', '}}
                  </span>
                  <span ng-if="\$ctrl.selectedLoanCoMakers.length === 0">-</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.cbuAccount">
                  <span class="key">CBU Account:</span>
                  <span class="value">{{\$ctrl.selectedLoan.cbuAccount.productNumber}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.pfAccount">
                  <span class="key">PF Account:</span>
                  <span class="value">{{\$ctrl.selectedLoan.pfAccount.productNumber}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.tpAccount">
                  <span class="key">TP Account:</span>
                  <span class="value">{{\$ctrl.selectedLoan.tpAccount.productNumber}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.linkedDepositAccount">
                  <span class="key">Allow Linked Deposit:</span>
                  <span class="value">{{\$ctrl.selectedLoan.allowLinkedDeposit ? 'Yes' : 'No'}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.linkedDepositAccount && \$ctrl.selectedLoan.allowLinkedDeposit">
                  <span class="key">Linked Deposit Account:</span>
                  <span class="value">{{\$ctrl.selectedLoan.linkedDepositAccount.productNumber}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.extraNumber">
                  <span class="key">Extra number:</span>
                  <span class="value">{{\$ctrl.selectedLoan.extraNumber || '-'}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoanPenalty">
                  <span class="key" ng-if="\$ctrl.selectedLoan.interestType === 'ANNUAL_RATE' || !\$ctrl.isAddOnRateAmortizationType()">Penalty rate:</span>
                  <span class="key" ng-if="\$ctrl.isAddOnRateAmortizationType()">Penalty rate (monthly add-on):</span>
                  <span class="value"
                        ng-if="\$ctrl.selectedLoanPenalty.type !== 'FIXED_AMOUNT'">{{\$ctrl.selectedLoanPenalty.rate | rate}}</span>
                  <span class="value"
                        ng-if="\$ctrl.selectedLoanPenalty.type === 'FIXED_AMOUNT'">{{\$ctrl.selectedLoanPenalty.rate | nxCurrency}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.penaltyMaturity">
                  <span class="key" ng-if="\$ctrl.selectedLoan.interestType === 'ANNUAL_RATE' || !\$ctrl.isAddOnRateAmortizationType()">Penalty maturity rate:</span>
                  <span class="key" ng-if="\$ctrl.isAddOnRateAmortizationType()">Penalty maturity rate (monthly add-on):</span>
                  <span class="value"
                        ng-if="\$ctrl.selectedLoan.penaltyMaturity.type !== 'FIXED_AMOUNT'">{{\$ctrl.selectedLoan.penaltyMaturity.rate | rate}}</span>
                  <span class="value"
                        ng-if="\$ctrl.selectedLoan.penaltyMaturity.type === 'FIXED_AMOUNT'">{{\$ctrl.selectedLoan.penaltyMaturity.rate | nxCurrency}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.pastDueInterestCharge">
                  <span class="key" ng-if="\$ctrl.selectedLoan.interestType === 'ANNUAL_RATE' || !\$ctrl.isAddOnRateAmortizationType()">Past due interest rate:</span>
                  <span class="key" ng-if="\$ctrl.isAddOnRateAmortizationType()">Past due interest rate (monthly add-on):</span>
                  <span class="value"
                        ng-if="\$ctrl.selectedLoan.pastDueInterestCharge.type !== 'FIXED_AMOUNT'">{{\$ctrl.selectedLoan.pastDueInterestCharge.rate | rate}}</span>
                  <span class="value"
                        ng-if="\$ctrl.selectedLoan.pastDueInterestCharge.type === 'FIXED_AMOUNT'">{{\$ctrl.selectedLoan.pastDueInterestCharge.rate | nxCurrency}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.pastDueMaturityInterestCharge">
                  <span class="key" ng-if="\$ctrl.selectedLoan.interestType === 'ANNUAL_RATE' || !\$ctrl.isAddOnRateAmortizationType()">Past due maturity rate:</span>
                  <span class="key" ng-if="\$ctrl.isAddOnRateAmortizationType()">Past due maturity rate (monthly add-on):</span>
                  <span class="value"
                        ng-if="\$ctrl.selectedLoan.pastDueMaturityInterestCharge.type !== 'FIXED_AMOUNT'">{{\$ctrl.selectedLoan.pastDueMaturityInterestCharge.rate | rate}}</span>
                  <span class="value"
                        ng-if="\$ctrl.selectedLoan.pastDueMaturityInterestCharge.type === 'FIXED_AMOUNT'">{{\$ctrl.selectedLoan.pastDueMaturityInterestCharge.rate | nxCurrency}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.remadeToLoans != null && \$ctrl.remadeToLoans.size() !== 0">
                  <span class="key">Remade to:</span>
                  <span class="value" ng-repeat="loans in \$ctrl.remadeToLoans">
                    {{loans.productNumber}}
                  </span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedLoan.dueAndDemandableThreshold">
                  <span class="key">Due & demandable threshold:</span>
                  <span class="value">{{\$ctrl.selectedLoan.dueAndDemandableThreshold}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Due & demandable:</span>
                  <span class="value">{{\$ctrl.selectedLoan.dueAndDemandable ? 'Yes' : 'No'}}</span>
                </div>
              </div>
            </div>

            <div class="tab-pane" id="account-information">
              <div class="detail-rows">
                <loan-account-information
                  loan="\$ctrl.selectedLoan"
                ></loan-account-information>
              </div>
            </div>

            <div class="tab-pane" id="metadata"
                 ng-if="\$ctrl.loanIsReleasedButNotClosed(\$ctrl.selectedLoan)">
              <div class="detail-rows">
                <div class="info-detail"><span class="key">Performance:</span><span class="value">{{\$ctrl.selectedLoan.metadata.performance | prettyEnum}}</span>
                </div>
                <div class="info-detail"><span class="key">Past-Due Classification:</span><span class="value">{{\$ctrl.selectedLoan.metadata.pastDueClassification | prettyEnum}}</span>
                </div>
                <div class="info-detail"><span class="key">Litigation:</span><span class="value">{{\$ctrl.selectedLoan.metadata.litigation | prettyBoolean}}</span>
                </div>
                <div class="info-detail"><span class="key">Restructured:</span><span class="value">{{\$ctrl.selectedLoan.metadata.restructured | prettyBoolean}}</span>
                </div>
                <div class="info-detail"><span class="key">Impaired:</span><span class="value">{{\$ctrl.selectedLoan.metadata.impaired | prettyBoolean}}</span>
                </div>
                <div class="info-detail"><span class="key">Provision rate:</span><span class="value">{{\$ctrl.selectedLoan.metadata.provisionRate}}%</span>
                </div>
                <div class="info-detail"><span class="key">Change mode:</span><span class="value">{{\$ctrl.selectedLoan.metadata.manualMetadata ? 'Manual' : 'Automatic'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </form-section>

    <div class="tab-menu">
      <ul class="nav-tabs">
        <li class="active">
          <a data-target="#amortization" data-toggle="tab">
            Amortization
          </a>
        </li>
        <li ng-if="\$ctrl.showAccrualHistory()">
          <a data-target="#accrual-history" data-toggle="tab">
            Accrual History
          </a>
        </li>
        <li ng-if="\$ctrl.displayNewHistory">
          <a data-target="#transaction-new" data-toggle="tab">
            Transaction History
          </a>
        </li>
        <li ng-if="!\$ctrl.displayNewHistory">
          <a data-target="#transaction" data-toggle="tab">
            Transaction history
          </a>
        </li>
        <li ng-if="\$ctrl.selectedLoan.uidLedger">
          <a data-target="#uid-ledger" data-toggle="tab">
            UID Ledger
          </a>
        </li>
        <li ng-if="\$ctrl.selectedLoan.discountChargesLedger">
          <a data-target="#discount-charges-ledger" data-toggle="tab">
            Discount Charges Ledger
          </a>
        </li>
        <li ng-if="\$ctrl.loanPDCsExist">
          <a data-target="#loan-pdc" data-toggle="tab">
            Loan PDC
          </a>
        </li>
        <li>
          <a data-target="#note-history" data-toggle="tab">
            Note History
          </a>
        </li>
        <li>
          <a data-target="#letter-history" data-toggle="tab">
            Letter History
          </a>
        </li>
      </ul>
    </div>

    <div class="tab-content">
      <div class="tab-pane active" id="amortization">
        <table ng-table-dynamic="\$ctrl.amortizationTable with \$ctrl.columnConfiguration" class="table">
          <tr ng-repeat-start="row in \$data"
              ng-click="row.id && \$ctrl.transactionClicked(row, \$event)"
              ng-class="{'selected': row.id && \$ctrl.selectedTransactionId === row.id, 'table__row--clickable': row.id}">
            <td ng-repeat="col in \$columns track by \$index"
                ng-class="\$ctrl.setCellColor(row, col)">
              {{ col.filterName ? \$ctrl.\$filter(col.filterName)(row[col.field]) : row[col.field] }}
            </td>
          </tr>
          <tr ng-repeat-end class="table__row--not-hoverable">
            <td colspan="100%">
              <div class="toggleable-panel-wrapper"
                   ng-class="{'toggleable-panel-wrapper--toggled': row.id && \$ctrl.selectedTransactionId === row.id}">
                <amortization-inline-panel
                  item="row"
                  selected-loan="\$ctrl.selectedLoan"
                  on-hide="\$ctrl.hideTransactionDetails()"
                >
                </amortization-inline-panel>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <div class="tab-pane" id="accrual-history" ng-if="\$ctrl.showAccrualHistory()">
        <loan-accrual-history loan="\$ctrl.selectedLoan" item="\$ctrl.item"></loan-accrual-history>
      </div>

      <div class="tab-pane" id="transaction-new" ng-if="\$ctrl.displayNewHistory">
        <loan-transaction-history loan="\$ctrl.selectedLoan" item="\$ctrl.item">
          <button class="btn btn-danger"
                  type="button"
                  command-access="{{\$ctrl.revertEntryCommandName(\$ctrl.item, 'LOAN_PAYMENT_REVERT')}}"
                  ng-if="\$ctrl.revertEntryAllowed(\$ctrl.item, \$ctrl.revertEntryCommandName(\$ctrl.item, 'LOAN_PAYMENT_REVERT')) && !\$ctrl.isExcessPayment(\$ctrl.item)"
                  ng-click="\$ctrl.revertPaymentFromEntry(\$ctrl.item)">
            Revert payment
          </button>
          <button class="btn btn-danger"
                  type="button"
                  command-access="{{\$ctrl.preterminationRevertCommandName(\$ctrl.item, 'LOAN_PRETERMINATION_REVERT')}}"
                  ng-if="\$ctrl.preterminationRevertAllowed(\$ctrl.item, \$ctrl.preterminationRevertCommandName(\$ctrl.item, 'LOAN_PRETERMINATION_REVERT'))"
                  ng-click="\$ctrl.revertPretermination(\$ctrl.item)">
            Revert pre-termination
          </button>
          <button class="btn btn-danger"
                  type="button"
                  command-access="{{\$ctrl.preterminationRevertCommandName(\$ctrl.item, 'LOAN_PRETERMINATION_CUSTOM_GL_REVERT')}}"
                  ng-if="\$ctrl.preterminationRevertToGlAllowed(\$ctrl.item, \$ctrl.preterminationRevertCommandName(\$ctrl.item, 'LOAN_PRETERMINATION_CUSTOM_GL_REVERT'))"
                  ng-click="\$ctrl.revertPreterminationToGl(\$ctrl.item)">
            Pre-termination revert to GL
          </button>
          <button class="btn btn-danger"
                  type="button"
                  command-access="UidRebateRevert"
                  ng-if="\$ctrl.rebateRevertAllowed(\$ctrl.item) && \$ctrl.item.entryType === 'APPLY_UID_LOAN_REBATE'"
                  ng-click="\$ctrl.revertRebate(\$ctrl.item)">
            Revert rebate
          </button>
          <button class="btn btn-danger"
                  type="button"
                  command-access="WriteOffLoanRevert"
                  ng-if="\$ctrl.revertWriteOffAllowed(\$ctrl.item) && \$ctrl.item.entryType === 'WRITE_OFF'"
                  ng-click="\$ctrl.revertWriteOff(\$ctrl.item)">
            Revert write off
          </button>
          <button class="btn btn-danger"
                  type="button"
                  command-access="{{\$ctrl.revertEntryCommandName(\$ctrl.item, 'LOAN_CUSTOM_GL_REVERT')}}"
                  ng-if="\$ctrl.revertEntryToCustomGlAllowed(\$ctrl.item, \$ctrl.revertEntryCommandName(\$ctrl.item, 'LOAN_CUSTOM_GL_REVERT'))"
                  ng-click="\$ctrl.revertPaymentToGl(\$ctrl.item.operationIds[0])">
            Payment revert to GL
          </button>
          <button type="button" class="btn btn-primary"
                  ng-if="\$ctrl.isPaymentReceiptAvailableForEntry(\$ctrl.item)"
                  ng-click="\$ctrl.showPaymentReceiptForEntry(\$ctrl.item)">
            Print payment invoice
          </button>
          <button type="button"
                  class="btn btn-primary"
                  command-access="ReleaseLoanByCash"
                  ng-if="\$ctrl.item.entryType === 'RELEASE_BY_CASH' && \$ctrl.isLoanReleaseByCashValidationReprintable"
                  ng-click="\$ctrl.printReleaseLoanByCashValidation(\$ctrl.item)">
            Print release loan by cash validation
          </button>
          <button type="button"
                  class="btn btn-primary"
                  command-access="ReleaseGroupLoanByCash"
                  ng-if="\$ctrl.item.entryType === 'RELEASE_BY_CASH_GROUP' && \$ctrl.isLoanReleaseGroupByCashValidationReprintable"
                  ng-click="\$ctrl.printReleaseGroupLoanByCashValidation(\$ctrl.item)">
            Print release group loan by cash validation
          </button>
          <button
            type="button"
            ng-if="\$ctrl.hasNoPaymentsAfter(\$ctrl.item.operationIds, \$ctrl.item.commandId)
                  && \$ctrl.item.entryType === 'CHECK_PAYMENT'
                  && (\$ctrl.item.status === 'PROCESSED')
                  && \$ctrl.loanIsReleasedButNotClosed(\$ctrl.selectedLoan)
                  && \$ctrl.item.entryGroup === 'PAY_LOAN'"
            command-access="ReturnLoanCheck"
            class="btn btn-danger"
            ng-click="\$ctrl.returnCheckForEntry(\$ctrl.item)">
            Return check
          </button>
          <button
            type="button"
            ng-if="\$ctrl.selectedLoan.status === 'ROPA' && \$ctrl.item.entryType === 'UPDATE_STATUS_ROPA'"
            command-access="TransferLoanToRopaRevert"
            class="btn btn-danger"
            ng-click="\$ctrl.revertTransferToRopa(\$ctrl.item)">
            Revert ROPA
          </button>
        </loan-transaction-history>
      </div>

      <div class="tab-pane" id="transaction" ng-if="!\$ctrl.displayNewHistory">
        <transaction-history product="\$ctrl.selectedLoan"
                             groups="\$ctrl.groups"
                             item="\$ctrl.item"
                             product-type="'LOAN'"
                             hide-available-balance-after="true"
                             hide-total-balance-after="true">
          <div class="inline-panel__container"
               ng-repeat="keyValueItem in \$ctrl.keyValueDetails(\$ctrl.item)">
            <label class="inline-panel__label">{{keyValueItem.label}}:</label>
            <p class="inline-panel__value">{{keyValueItem.value}}</p>
          </div>
          <button class="btn btn-danger"
                  type="button"
                  command-access="{{\$ctrl.revertCommandName(\$ctrl.item, 'LOAN_PAYMENT_REVERT')}}"
                  ng-if="\$ctrl.revertAllowed(\$ctrl.item, \$ctrl.revertCommandName(\$ctrl.item, 'LOAN_PAYMENT_REVERT'))"
                  ng-click="\$ctrl.revertPayment(\$ctrl.item)">
            Revert payment
          </button>
          <button class="btn btn-danger"
                  type="button"
                  command-access="{{\$ctrl.revertCommandName(\$ctrl.item, 'LOAN_CUSTOM_GL_REVERT')}}"
                  ng-if="\$ctrl.revertToCustomGlAllowed(\$ctrl.item, \$ctrl.revertCommandName(\$ctrl.item, 'LOAN_CUSTOM_GL_REVERT'))"
                  ng-click="\$ctrl.revertPaymentToGl(\$ctrl.item.id)"
          >
            Payment revert to GL
          </button>
          <button type="button" class="btn btn-primary"
                  ng-if="\$ctrl.isPrintReceiptAvailable(\$ctrl.item)"
                  ng-click="\$ctrl.showPaymentReceipt(\$ctrl.item)">
            Print payment invoice
          </button>
          <button
            type="button"
            ng-if="\$ctrl.hasNoPaymentsAfter([\$ctrl.item.id], \$ctrl.item.commandId)
                   && \$ctrl.item.operationGroup === 'DEPOSIT_CHECK'
                   && (\$ctrl.item.status === 'PROCESSED')
                   && !\$ctrl.item.attributes['RETURN_CHECK_OPERATION_ID']
                   && !\$ctrl.item.attributes['LATE_CHECK']"
            command-access="ReturnLoanCheck"
            class="btn btn-danger"
            ng-click="\$ctrl.returnCheck(\$ctrl.item)">
            Return check
          </button>
          <button
            type="button"
            ng-if="\$ctrl.selectedLoan.status === 'ROPA' && \$ctrl.item.entryType === 'UPDATE_STATUS_ROPA'"
            command-access="TransferLoanToRopaRevert"
            class="btn btn-danger"
            ng-click="\$ctrl.revertTransferToRopa(\$ctrl.item)">
            Revert ROPA
          </button>
        </transaction-history>
      </div>

      <div class="tab-pane" id="uid-ledger" ng-if="\$ctrl.selectedLoan.uidLedger">
        <uid-ledger
          uid-ledger="\$ctrl.selectedLoan.uidLedger"
          show-status="true">
        </uid-ledger>
      </div>

      <div class="tab-pane" id="discount-charges-ledger"
           ng-if="\$ctrl.selectedLoan.discountChargesLedger">
        <discount-charges-ledger
          discount-charges="\$ctrl.selectedLoan.discountChargesLedger"
          show-status="true">
        </discount-charges-ledger>
      </div>

      <div class="tab-pane" id="loan-pdc" ng-if="\$ctrl.selectedLoan && \$ctrl.loanPDCsExist">
        <loan-pdc-tab loan="\$ctrl.selectedLoan"></loan-pdc-tab>
      </div>

      <div class="tab-pane" id="note-history">
        <note-history product-id="\$ctrl.selectedLoan.id"
                      product-type="'LOAN'"></note-history>
      </div>
      <div class="tab-pane" id="letter-history">
        <letter-history loan="\$ctrl.selectedLoan">
        </letter-history>
      </div>
    </div>

  </div>

  <delete-loan-confirmation on-delete-loan-confirmation-ready="\$ctrl.onDeleteLoanConfirmationReady" ></delete-loan-confirmation>
  <preterminate-revert-confirmation on-preterminate-revert-confirmation-ready="\$ctrl.onPreterminateRevertConfirmationReady" ></preterminate-revert-confirmation>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/customer-loans.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;